export default "__VITE_ASSET__bd3173d9__"